import { useTranslation } from "@/hooks/useTranslation"
import { StatusTag } from "@/molecules/StatusTag"

import type { Status } from "@/molecules/StatusTag"
import type { AiDecisionOutcome } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.types"

const OUTCOME_STATUS: Record<AiDecisionOutcome, Status> = {
  blocked: "failed",
  wouldBlock: "warning",
  allowed: "success"
}

// What the enforcement point did about a tool call
export const AiDecisionOutcomeTag = ({
  outcome
}: {
  outcome: AiDecisionOutcome
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.decisions.outcomes"
  })

  return <StatusTag status={OUTCOME_STATUS[outcome]} text={t(outcome)} />
}
